import React from 'react'
import { FormCheckbox } from '@myxplor/forms'

export const defaultValues = {
  Declaration: {
    WWCC: undefined,
    policeCheck: undefined,
    ASFA: undefined,
    ASIC: undefined,
  }
}

export const Declarations = ({ onChange, loading, values }) => (
  <fieldset>
    <legend>Declaration</legend>

    <FormCheckbox
      name="Declaration.WWCC"
      label="A working with children card check"
      hint="A working with children card check issued by the authority responsible for working with children cards in the State or Territory in relation to care provided by a child care service of the provider"
      onChange={onChange}
      loading={loading}
      value={values.Declaration.WWCC}
      compact
    />

    <FormCheckbox
      name="Declaration.policeCheck"
      label="An Australian National Policy Criminal History Check"
      hint="An Australian National Policy Criminal History Check obtained from the relevant state or territory police service or an agency accredited by the Australian Criminal Intelligence Commission, and obtained no more than six months previously"
      onChange={onChange}
      loading={loading}
      value={values.Declaration.policeCheck}
      required
      compact
    />

    <FormCheckbox
      name="Declaration.ASFA"
      label="A National Personal Insolvency Index"
      hint="A National Personal Insolvency Index check performed using the Bankruptcy Register Search service provided by the Australian Financial Security Authority (AFSA)"
      value={values.Declaration.ASFA}
      onChange={onChange}
      loading={loading}
      required
      compact
    />

    <FormCheckbox
      name="Declaration.ASIC"
      label="A Current and Historical personal name extract search"
      hint="A Current and Historical personal name extract search of the records of the Australian Securities and Investments Commission (ASIC)"
      value={values.Declaration.ASIC}
      onChange={onChange}
      loading={loading}
      required
      compact
    />

    <hr />

    Have the above checks revealed any adverse events?
    <div className="radioButtonGroup">
      <label>
        <input
          type="radio"
          name="Declaration.adverseEvents"
          onChange={() => onChange('PreviousHistory.entitySubjectTo', true)}
          disabled={loading}
        />
        Yes
      </label>
      <label>
        <input
          type="radio"
          name="Declaration.adverseEvents"
          onChange={() => onChange('PreviousHistory.entitySubjectTo', false)}
          disabled={loading}
        />
        No
      </label>
    </div>
  </fieldset>
)



// WEBPACK FOOTER //
// ./src/providers-registrations/personnel-list/register-mancon-action/form/declarations.jsx